import type { AiUsageSummary } from '@bliks-io/contracts';

export function totalCallsOf(summary: AiUsageSummary | undefined): number {
  if (!summary) return 0;
  return summary.generationCount + summary.embeddingCount + summary.transcriptionCount;
}

export function totalTokensOf(summary: AiUsageSummary | undefined): number {
  if (!summary) return 0;
  return summary.totalInputTokens + summary.totalOutputTokens;
}
